require('./bootstrap');

require("bootstrap");


$(window).on('scroll', function () {
    let scrollTop = $(this).scrollTop();

    if (scrollTop > 5) {
        $("header, body").addClass("scroll");
    } else {
        $("header, body").removeClass("scroll");
    }
});



$(".hamburger").on("click", function () {
    $(".menu-phone").addClass("show");
})
$(".menu-phone").find('.exit').on("click", function () {
    $(".menu-phone").removeClass("show");
})

$(".scroll-to").click(function (e) {
    e.preventDefault();
    const target_id = $(this).attr("href");
    const $toElement = $(target_id);

    if ($toElement.length) {
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: $toElement.offset().top
            },
            1000
        );
    }

    $(".modal").modal("hide");

    return false;
});


$(".up-btn").on("click", function (e) {
    $([document.documentElement, document.body]).animate(
        {
            scrollTop: 0
        },
        1000
    );
});

//--Promocion banco estado--
var widthView = screen.width;
if (widthView <= 992) {
    if ($(".loading").fadeOut()) {
        $('#ligthbox').addClass('show')
    }
} else {
    if ($(".loading").fadeOut()) {
        $('#start-flotanting').addClass('show')
    }
    $('#start-flotanting').on('click', function () {
        $("#open-ligthbox").addClass('show')
        $(this).removeClass('show')
    });
    $("#open-ligthbox .image").on('click', function () {
        $('#ligthbox').toggleClass('show')
    })
    $('#close-flotanting').on('click', function () {
        $('#open-ligthbox').removeClass('show');
    })
}
$('#ligthbox').on('click', function () {
    $(this).removeClass('show')
})

//--Promocion banco estado


